import { fromJS } from 'immutable'
import {
  LEAVE_REQUEST_CREATE_REQUEST,
  LEAVE_REQUEST_CREATE_SUCCESS,
  LEAVE_REQUEST_CREATE_FAILURE,
  LEAVE_REQUEST_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LEAVE_REQUEST_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case LEAVE_REQUEST_CREATE_SUCCESS:
      return state
        .set('createdLeaveRequest', fromJS(action.payload.createdLeaveRequest))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case LEAVE_REQUEST_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('createdLeaveRequest', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case LEAVE_REQUEST_CREATE_RESET:
      return state
        .delete('createdLeaveRequest')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leave-request/leave-request-create-reducer.js